import { exportToCSV, exportToExcel, exportToPdf } from '../exports';

const dataTransformation = (columns, data, type = '') =>
  data.map((itm) => {
    const output = {};
    Object.keys(itm).forEach((dataKey) => {
      if (columns.some((column) => column['name'] === dataKey)) {
        const currentCol = columns.find((col) => col['name'] === dataKey);

        const alias = dataKey;
        const label = currentCol['label'];
        const value = itm[dataKey];

        type === 'pdf' && (output[alias] = { label, value });
        !type && (output[label] = value);
      }
    });
    return output;
  });

export const exportToFile = (tableData, type, fileName = 'drivers') => {
  const { columns, data } = tableData;
  const outputData = dataTransformation(columns, data);

  if (type === 'csv') {
    exportToCSV(outputData, fileName);
  } else if (type === 'xls') {
    exportToExcel(outputData, fileName);
  }
};

export const generatePdfDocument = (documentData, title, fontSize = 8) => {
  const { columns, data } = documentData;
  const outputData = dataTransformation(columns, data);
  const headers = [];
  columns.forEach((el) => {
    if (el.type === 'link') return;
    headers.push({
      text: el.label,
      style: 'tableHeader',
      alignment: 'center',
    });
  });

  const body = [];
  outputData.forEach((itm) => {
    const row = [];
    headers.forEach((head) => {
      row.push(itm[head.text]);
    });
    body.push(row);
  });

  const table = [headers, ...body];
  const width = headers.map((el) => {
    return 'auto';
  });

  const styles = {
    table: {
      fontSize,
    },
  };

  exportToPdf({ table, styles, fileName: title, width });
};
